import { canCallApp, defaultConfirmModal, config, isApp } from './utils';
import * as $ from 'jquery';
import { post } from './utils/ajax';
import { getProductUrl } from './utils/url-helper';
import { ProductRepublishEvent } from './Shared/events';
//
// Clone endpoint call
const cloneProduct = async ( productId, btn, oneClickClone ) => {
    if (oneClickClone) { 
        cloneProductLoading(btn);
        post( '/api/v4/products/clone', { 'productId': productId, 'publish': oneClickClone } )
        .then( async response => {
            if ( response.productId ) {
                cloneProductLoading(btn, true);
                btn.setAttribute( 'disabled', '' );
                removeCard( btn );
                const modal = document.querySelector('#modal-republish-pre');
                $( modal ).modal( 'hide' );
                let redirect_to = await getProductUrl( response.productId ) + '?load-modal=modal-republish-message';
                if (isApp) {
                    redirect_to = redirect_to.replace('www.', 'app.');
                }
                window.location.href = redirect_to;
            }
        } );
    } else {
        cloneProductLoading(btn);
        if ( isApp && canCallApp( 'cloneProduct' ) ) {
            Trendier.cloneProduct( productId );
            cloneProductLoading(btn, true);
            btn.setAttribute( 'disabled', '' );
            removeCard( btn );
            const modal = document.querySelector('#modal-republish-pre');
            $( modal ).modal( 'hide' );
        } else {
            post(
                '/api/v4/products/clone',
                { 'productId': productId, 'publish': oneClickClone }
            )
            .then(response => {
                if ( response.productId ) {
                    cloneProductLoading(btn, true);
                    btn.setAttribute( 'disabled', '' );
                    removeCard( btn );
                    const modal = document.querySelector('#modal-republish-pre');
                    $( modal ).modal( 'hide' );
                    window.location.href = `/publish?product=${response.productId}`;
                }
            });
        }
    }
};

const cloneProductLoading = (btn, loaded = false) => {
  const republishBadgeText = btn.parentElement
      .querySelector('.republish-badge-text');
  const icon = btn.parentElement.querySelector('button');
  const republishSpinner = btn.querySelector('.spinner-border');
  if (republishBadgeText) {
    republishBadgeText.innerHTML = 'Cargando...';
    republishBadgeText.classList.toggle('showing', loaded === false);
    icon.classList.toggle('rotate', loaded === false);
  }
  if (republishSpinner) {
    republishSpinner.classList.toggle('d-none', loaded !== false);
    republishSpinner.parentElement.toggleAttribute('disabled', loaded === false);
  }
};

//
// Clone product buttons set up
const cloneProductSetupBtns = () => {
    setRepublishModal();
    document.querySelectorAll('.js-clone-product-button').forEach( btn => {
        if ( 'alertText' in btn.dataset ) {
            const modal = document.querySelector('#default-modal');
            modal.querySelector('.js-dialog-success').innerText = btn.dataset.alertAcceptText;
            modal.querySelector('.js-for-dialog[data-dismiss="modal"]').innerText = btn.dataset.alertCancelText;
            btn.addEventListener( 'click', e => {
                e.preventDefault();
                defaultConfirmModal(
                    btn.dataset.alertText,
                    () => cloneProduct(btn.dataset.productId, btn, false),
                    () => $( modal ).modal('hide')
                );
            });
        } else {
            const modal = document.querySelector('#modal-republish-pre');
            if ( modal ) {
                btn.addEventListener( 'click', e => {
                    e.preventDefault();
                    modal.querySelectorAll( 'button' ).forEach( modalBtn => modalBtn.dataset.productId = btn.dataset.productId );
                    $( modal ).modal( 'show' );
                } );
            }
        }
    })
};

const setRepublishModal = () => {
    const modal = document.querySelector('#modal-republish-pre');
    if ( modal ) {
        const editBtn = modal.querySelector('.js-edit-product');
        const republishBtn = modal.querySelector('.js-republish-product');

        editBtn.addEventListener( 'click', () => {
            const productRepublishEvent = new ProductRepublishEvent( 'edit' );
            document.dispatchEvent( productRepublishEvent );
            cloneProduct(editBtn.dataset.productId, editBtn, false);
        } );

        republishBtn.addEventListener( 'click', () => {
            const productRepublishEvent = new ProductRepublishEvent( 'republish' );
            document.dispatchEvent( productRepublishEvent );
            cloneProduct(republishBtn.dataset.productId, republishBtn, true);
        } );

        $( modal ).on( 'shown.bs.modal', () => {
            const productRepublishEvent = new ProductRepublishEvent( 'open' );
            document.dispatchEvent( productRepublishEvent );
        } );
    }
};

const removeCard = ( btn ) => {
    const productCard = btn.closest( '.card-img' );
    if ( productCard ) {
        const productJson = productCard.nextElementSibling;
        if ( productJson && productJson.classList.contains( 'js-product-data' ) ) {
            productJson.remove();
        }
        productCard.remove();
    }
};


export default cloneProductSetupBtns;